const sendToDataLayer = (eventName, eventParams) => {
  window.sendToDataLayer = window.sendToDataLayer || (() => {});
  window.sendToDataLayer(eventName, eventParams);
};
const GTMEvents = {
  LateralMenuLinkMenu: menuLinkText => {
    sendToDataLayer('menu_click', {
      id: 'MOD-MAIN-LATERAL-MENU-LINK-MENU',
      section: 'menu',
      option: menuLinkText
    });
  },
  LateralMenuLinkSubMenu: (menuLinkText, subMenuLinkText) => {
    sendToDataLayer('menu_click', {
      id: 'MOD-MAIN-LATERAL-MENU-LINK-SUBMENU',
      section: 'menu',
      option: `${menuLinkText} - ${subMenuLinkText}`
    });
  },
  BtnClickReadDocumentToSign: (procedureType, nameDocument) => {
    sendToDataLayer('button_click', {
      id: "MOD-BTN-READ-DOCUMENT-SIGNATURE",
      section: 'Mis Tramites',
      option: 'click documento',
      sub_section: procedureType,
      procedure_type: 'Firma digital',
      procedure_name: `Firma digital - ${nameDocument}`,
      step_name: 'Conformidad documento',
      location: `Estado de mis tramites - ${procedureType}`
    });
  },
  BtnClickAgreeOrRejectDocumentInSignature: (agreeToSign, procedureType, nameDocument) => {
    sendToDataLayer('button_click', {
      section: 'Mis Tramites',
      option: `${agreeToSign}`,
      //Acepto | No Acepto
      sub_section: procedureType,
      procedure_type: 'Firma digital',
      procedure_name: `Firma digital - ${nameDocument}`,
      step_name: 'Conformidad documento',
      location: `Estado de mis tramites - ${procedureType}`
    });
  },
  BtnInitSignatureFlow: (buttonText, procedureType) => {
    sendToDataLayer('button_click', {
      id: "MOD-BTN-INIT-SIGNATURE-FLOW",
      section: 'Mis Tramites',
      option: `${buttonText}`,
      //Firmar Documentos | Rechazar documentos
      sub_section: procedureType,
      procedure_type: 'Firma digital',
      procedure_name: `Firma digital - ${buttonText}`,
      step_name: 'Firmar documentos',
      location: `Estado de mis tramites - ${procedureType}`
    });
  }
};

export { GTMEvents as G };
